import { consoleRequest } from '@/console/api/http'
import { McisCutoverRollbackResendRequest, McisCutoverRollbackResendResponse } from '@/console/api/types'

/**
 * MCIS 컷오버 롤백 재송신(LOGISPRD-14487, moms-be PR #4568, `@devOpsGate.allows` — MOMS_ENG 단독).
 * 성공 본문에 `meta` 래퍼가 없어(규약 B) 그대로 돌려준다. 409(컷오버 flag ON)도 같은 본문이라 호출부가 읽는다.
 * 재시도하지 않는다 — 실행 결과를 놓치면 다시 판정해서 확인한다.
 */
const ROLLBACK_RESEND_URL = '/api/v1/outbound-result-erp/mcis-cutover/rollback-resend'

export const requestMcisCutoverRollbackResend = (request: McisCutoverRollbackResendRequest): Promise<McisCutoverRollbackResendResponse> =>
  consoleRequest.post<McisCutoverRollbackResendResponse, McisCutoverRollbackResendRequest>(ROLLBACK_RESEND_URL, request)
